/* One bar per playground showing the shape of its task list: done, in
   progress, blocked, to do — in that order, so the eye reads progress
   left to right. */
export function TaskStrip({ tasks }) {
  if (!tasks.length) return <div className="strip" aria-hidden="true" />;

  const by = { done: 0, "in-progress": 0, blocked: 0, todo: 0 };
  for (const t of tasks) by[t.status] = (by[t.status] || 0) + 1;

  const seg = (k, cls) =>
    by[k] ? <i key={k} className={cls} style={{ flex: by[k] }} /> : null;

  return (
    <div
      className="strip"
      role="img"
      aria-label={
        by.done + " done, " + by["in-progress"] + " in progress, " +
        by.blocked + " blocked, " + by.todo + " to do"
      }
    >
      {seg("done", "s-done")}
      {seg("in-progress", "s-prog")}
      {seg("blocked", "s-block")}
      {seg("todo", "s-todo")}
    </div>
  );
}
